0,   100.00, 32, 0, 1, 60.00     / PSS(R)E-32.2    MON, DEC 08 2014  17:27
IEEE 9 BUS CASE - 3G - 3L

     1,'BUS1        ',  16.5000,3,   1,   1,   1,1.04000,   0.0000
     2,'BUS2        ',  18.0000,2,   2,   2,   1,1.02500,   9.2800
     3,'BUS3        ',  13.8000,2,   2,   3,   1,1.02500,   4.6648
     4,'BUS4        ', 230.0000,1,   1,   1,   1,1.02579,  -2.2168
     5,'BUS5        ', 230.0000,1,   1,   4,   2,0.99563,  -3.9888
     6,'BUS6        ', 230.0000,1,   1,   5,   2,1.01265,  -3.6874
     7,'BUS7        ', 230.0000,1,   2,   2,   1,1.02577,   3.7197
     8,'BUS8        ', 230.0000,1,   2,   6,   2,1.01588,   0.7275
     9,'BUS9        ', 230.0000,1,   2,   3,   1,1.03235,   1.9667
0 / END OF BUS DATA, BEGIN LOAD DATA
     5,'1 ',1,   1,   1,   125.000,    50.000,     0.000,     0.000,     0.000,     0.000,   1,1
     6,'1 ',1,   1,   1,    90.000,    30.000,     0.000,     0.000,     0.000,     0.000,   1,1
     8,'1 ',1,   1,   1,   100.000,    35.000,     0.000,     0.000,     0.000,     0.000,   1,1
0 / END OF LOAD DATA, BEGIN FIXED SHUNT DATA
0 / END OF FIXED SHUNT DATA, BEGIN GENERATOR DATA
     1,'1 ',    71.641,    27.046,   300.000,  -300.000,1.04000,     0,   260.000, 1.00000E-4, 1.00000E-1, 0.00000E+0, 0.00000E+0,1.00000,1,  100.0,   250.000,    10.000,   1,1.0000
     2,'1 ',   163.000,     6.654,   300.000,  -300.000,1.02500,     0,   310.000, 1.00000E-4, 2.10000E-1, 0.00000E+0, 0.00000E+0,1.00000,1,  100.0,   300.000,    10.000,   1,1.0000
     3,'1 ',    85.000,   -10.860,   300.000,  -300.000,1.02500,     0,   280.000, 1.00000E-4, 2.10000E-1, 0.00000E+0, 0.00000E+0,1.00000,1,  100.0,   270.000,    10.000,   1,1.0000
0 / END OF GENERATOR DATA, BEGIN BRANCH DATA
     4,     5,'1 ', 1.00000E-2, 8.50000E-2,   0.17600,  250.00,  250.00,  250.00,  0.00000,  0.00000,  0.00000,  0.00000,1,1,   0.00,   1,1.0000
     4,     6,'1 ', 1.70000E-2, 9.20000E-2,   0.15800,  250.00,  250.00,  250.00,  0.00000,  0.00000,  0.00000,  0.00000,1,1,   0.00,   1,1.0000
     5,     7,'1 ', 3.20000E-2, 1.61000E-1,   0.30600,  250.00,  250.00,  250.00,  0.00000,  0.00000,  0.00000,  0.00000,1,1,   0.00,   1,1.0000
     6,     9,'1 ', 3.90000E-2, 1.70000E-1,   0.35800,  150.00,  150.00,  150.00,  0.00000,  0.00000,  0.00000,  0.00000,1,2,   0.00,   1,1.0000
     7,     8,'1 ', 8.50000E-3, 7.20000E-2,   0.14900,  250.00,  250.00,  250.00,  0.00000,  0.00000,  0.00000,  0.00000,1,1,   0.00,   1,1.0000
     8,     9,'1 ', 1.19000E-2, 1.00800E-1,   0.20900,  150.00,  150.00,  150.00,  0.00000,  0.00000,  0.00000,  0.00000,1,1,   0.00,   1,1.0000
0 / END OF BRANCH DATA, BEGIN TRANSFORMER DATA
     1,     4,     0,'T1',1,1,1, 0.00000E+0, 0.00000E+0,2,'            ',1,   1,1.0000
 0.00000E+0, 5.76000E-2,   100.00
1.00000,   0.000,   0.000,     0.00,     0.00,     0.00, 0,      0, 1.10000, 0.90000, 1.10000, 0.90000,  33, 0, 0.00000, 0.00000,  0.000
1.00000,   0.000
     2,     7,     0,'T2',1,1,1, 0.00000E+0, 0.00000E+0,2,'            ',1,   1,1.0000
 0.00000E+0, 6.25000E-2,   100.00
1.00000,   0.000,   0.000,     0.00,     0.00,     0.00, 0,      0, 1.10000, 0.90000, 1.10000, 0.90000,  33, 0, 0.00000, 0.00000,  0.000
1.00000,   0.000
     9,     3,     0,'T3',1,1,1, 0.00000E+0, 0.00000E+0,2,'            ',1,   1,1.0000
 0.00000E+0, 5.86000E-2,   100.00
1.00000,   0.000,   0.000,     0.00,     0.00,     0.00, 0,      0, 1.10000, 0.90000, 1.10000, 0.90000,  33, 0, 0.00000, 0.00000,  0.000
1.00000,   0.000
0 / END OF TRANSFORMER DATA, BEGIN AREA DATA
   1,     1,    50.000,    10.000,'AREA1       '
   2,     2,    50.000,    10.000,'AREA2       '
0 / END OF AREA DATA, BEGIN TWO-TERMINAL DC DATA
0 / END OF TWO-TERMINAL DC DATA, BEGIN VSC DC LINE DATA
0 / END OF VSC DC LINE DATA, BEGIN IMPEDANCE CORRECTION DATA
0 / END OF IMPEDANCE CORRECTION DATA, BEGIN MULTI-TERMINAL DC DATA
0 / END OF MULTI-TERMINAL DC DATA, BEGIN MULTI-SECTION LINE DATA
0 / END OF MULTI-SECTION LINE DATA, BEGIN ZONE DATA
   1,'ZONE1       '
   2,'ZONE2       '
   3,'ZONE3       '
   4,'ZONE4       '
   5,'ZONE5       '
   6,'ZONE6       '
0 / END OF ZONE DATA, BEGIN INTER-AREA TRANSFER DATA
0 / END OF INTER-AREA TRANSFER DATA, BEGIN OWNER DATA
   1,'OWNER1      '
   2,'OWNER2      '
0 / END OF OWNER DATA, BEGIN FACTS DEVICE DATA
0 / END OF FACTS DEVICE DATA, BEGIN SWITCHED SHUNT DATA
0 / END OF SWITCHED SHUNT DATA, BEGIN GNE DATA
0 / END OF GNE DATA
Q
